























import Field from '@/components/form/Field.vue'
import { Component, Prop, Provide, Vue } from 'vue-property-decorator';
import { validationMixin } from 'vuelidate';
import { StoreActions } from '@/store';
import { LoginData } from '@/model/auth.model';
import { required, email } from 'vuelidate/lib/validators';


@Component({
  mixins: [validationMixin],
  components: {
    Field,
  },
  validations: {
    login: {
      email: {
        required,
        email,
      },
      password: {
        required,
      },
    }
  }
})
export default class Login extends Vue {
  @Provide() login: LoginData = {
    email: '',
    password: '',
  }

  async submit() {
    await this.$store.dispatch(StoreActions.Login, this.login);
    if (this.$store.state.loggedIn) {
      this.$router.push(this.$route.query.redirect as string || '/')
    }
  }

}
